import {
  GET_CERTIFICATES,
  GET_CERTIFICATE_BY_ID,
  CREATE_CERTIFICATE,
  UPDATE_CERTIFICATE,
  DELETE_CERTIFICATE
} from '../../../api/master-data/certificate/certificate.js';

const state = {
  certificates: [],
  certificateDetail: {},
  totalItems: 0,
  totalPages: 0,
  currentPage: 1,
  limit: 9,
  loading: false,
  error: null
};

const mutations = {
  SET_CERTIFICATES(state, data) {
    state.certificates = data.data || [];
    state.totalItems = data.totalItems || 0;
    state.totalPages = data.totalPages || 0;
    state.currentPage = data.page || 1;
    state.limit = data.limit || 9;
  },
  SET_CERTIFICATE_DETAIL(state, data) {
    state.certificateDetail = data;
  },
  SET_LOADING(state, status) {
    state.loading = status;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  CLEAR_ERROR(state) {
    state.error = null;
  }
};

const actions = {
  async getCertificates({ commit }, params) {
    commit('SET_LOADING', true);
    commit('CLEAR_ERROR');
    try {
      const response = await GET_CERTIFICATES(params);
      commit('SET_CERTIFICATES', response.data.data);
      return response.data.data;
    } catch (error) {
      commit('SET_ERROR', error.message);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async getCertificateById({ commit }, id) {
    commit('SET_LOADING', true);
    commit('CLEAR_ERROR');
    try {
      const response = await GET_CERTIFICATE_BY_ID(id);
      commit('SET_CERTIFICATE_DETAIL', response.data);
      return response.data;
    } catch (error) {
      commit('SET_ERROR', error.message);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async createCertificate({ commit }, data) {
    commit('SET_LOADING', true);
    commit('CLEAR_ERROR');
    try {
      const response = await CREATE_CERTIFICATE(data);
      return response.data;
    } catch (error) {
      commit('SET_ERROR', error.message);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async updateCertificate({ commit }, { id, data }) {
    commit('SET_LOADING', true);
    commit('CLEAR_ERROR');
    try {
      const response = await UPDATE_CERTIFICATE(id, data);
      return response.data;
    } catch (error) {
      commit('SET_ERROR', error.message);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async deleteCertificate({ commit }, id) {
    commit('SET_LOADING', true);
    commit('CLEAR_ERROR');
    try {
      const response = await DELETE_CERTIFICATE(id);
      return response.data;
    } catch (error) {
      commit('SET_ERROR', error.message);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  }
};

const getters = {
  getCertificates: state => state.certificates,
  getCertificateDetail: state => state.certificateDetail,
  getTotalItems: state => state.totalItems,
  getTotalPages: state => state.totalPages,
  getCurrentPage: state => state.currentPage,
  getLimit: state => state.limit,
  getLoading: state => state.loading,
  getError: state => state.error
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};